import { useQuery } from "@tanstack/react-query"
import { useAuth } from "@/hooks"
import { ConfigContext, configAPI, queryKeys } from "@/utils"

export function ConfigProvider({ children }: { children: React.ReactNode }) {
  const { company } = useAuth()
  const { data } = useQuery({
    queryKey: queryKeys.config,
    queryFn: configAPI.fetch,
    enabled: !!company?.id,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  })

  return <ConfigContext.Provider value={data ?? null}>{children}</ConfigContext.Provider>
}
